var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDesktopCurveRtl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 442,
  height: 894,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#desktop-curve-rtl_svg__a)",
  fillRule: "evenodd",
  d: "M0 .5h442v548.578c0 95.248-98.945 172.461-221 172.461S0 798.752 0 894V.5Z",
  clipRule: "evenodd"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#desktop-curve-rtl_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.3,
  fillRule: "evenodd",
  d: "M0 0h442v525.891c0 93.09-98.945 168.554-221 168.554S0 769.91 0 863V0Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "desktop-curve-rtl_svg__a",
  x1: 442,
  x2: 0,
  y1: 447.25,
  y2: 447.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0C71E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00CE81"
})), /*#__PURE__*/React.createElement("filter", {
  id: "desktop-curve-rtl_svg__b",
  width: 458,
  height: 879,
  x: -8,
  y: -8,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_4613_104984"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_4613_104984",
  result: "shape"
})))));
export { SvgDesktopCurveRtl as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQyIiBoZWlnaHQ9Ijg5NCIgdmlld0JveD0iMCAwIDQ0MiA4OTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAwLjVINDQyVjU0OS4wNzhDNDQyIDY0NC4zMjYgMzQzLjA1NSA3MjEuNTM5IDIyMSA3MjEuNTM5Qzk4Ljk0NTEgNzIxLjUzOSAwIDc5OC43NTIgMCA4OTRWNzIxLjUzOVY1NDkuMDc4VjM3Ni42MTdWMC41WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzQ2MTNfMTA0OTg0KSIvPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9iXzQ2MTNfMTA0OTg0KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMCAwSDQ0MlY1MjUuODkxQzQ0MiA2MTguOTgxIDM0My4wNTUgNjk0LjQ0NSAyMjEgNjk0LjQ0NUM5OC45NDUxIDY5NC40NDUgMCA3NjkuOTEgMCA4NjNWNjk0LjQ0NVY1MjUuODkxVjM1Ny4zMzZWMFoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuMyIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2JfNDYxM18xMDQ5ODQiIHg9Ii04IiB5PSItOCIgd2lkdGg9IjQ1OCIgaGVpZ2h0PSI4NzkiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlR2F1c3NpYW5CbHVyIGluPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHN0ZERldmlhdGlvbj0iNCIvPgo8ZmVDb21wb3NpdGUgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9ImluIiByZXN1bHQ9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXJfNDYxM18xMDQ5ODQiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzQ2MTNfMTA0OTg0IiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDYxM18xMDQ5ODQiIHgxPSI0NDIiIHkxPSI0NDcuMjUiIHgyPSIzLjcwNDgxZS0wNyIgeTI9IjQ0Ny4yNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMEM3MUU3Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzAwQ0U4MSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";